import React, { useId } from 'react';

import { Box, Flex, Text } from '@rover/kibble/core';
import useTheme from '@rover/kibble/themes/useTheme';

type CurrencyInputProps = {
  label: string;
  value: string;
  currencySymbol: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onBlur: () => void;
  'data-testid': string;
};

const CurrencyInput = ({
  label,
  value,
  currencySymbol,
  onChange,
  onBlur,
  'data-testid': dataTestId,
}: CurrencyInputProps): JSX.Element => {
  const theme = useTheme();
  const inputId = useId();
  const labelId = `${inputId}-label`;
  const currencyId = `${inputId}-currency`;

  return (
    <Flex flexDirection="column" flex="1">
      <Box webAs="label" id={labelId} webAsProps={{ htmlFor: inputId }} mb="1x">
        <Text size="100" textColor="primary" fontWeight="semibold">
          {label}
        </Text>
      </Box>
      <Flex
        flexDirection="row"
        alignItems="center"
        border="2px solid"
        borderColor={theme.colors.interactive_border.primary_base}
        borderRadius="secondary"
        px="3x"
        py="2x"
        sx={{
          '&:focus-within': {
            borderColor: theme.colors.interactive_border.primary_pressed,
          },
        }}
      >
        <Box id={currencyId} mr="2x">
          <Text size="200" textColor="secondary">
            {currencySymbol}
          </Text>
        </Box>
        <input
          id={inputId}
          inputMode="numeric"
          pattern="[0-9]*"
          value={value}
          onChange={onChange}
          onBlur={onBlur}
          aria-labelledby={`${labelId} ${currencyId}`}
          data-testid={dataTestId}
          style={{
            border: 'none',
            outline: 'none',
            fontSize: theme.text[200].fontSize,
            lineHeight: theme.paragraph[200].lineHeight,
            textAlign: 'right',
            padding: 0,
            width: '100%',
          }}
        />
      </Flex>
    </Flex>
  );
};

export default CurrencyInput;
